import { BrowserRouter } from 'react-router-dom';
import { AllRoutes } from './index';
import React from 'react';

const Routes = React.memo(() => {
    return (
        <BrowserRouter>
            <AllRoutes />
        </BrowserRouter>
    );
});

export default Routes;
